import { style } from '@vtex/admin-ui'

export const container = style({
  minHeight: '450px',
})
